import {toQueryString} from '@s-ui/js/lib/string'

import {SeoErrorsFactory} from '../Errors/factory.js'
import SeoMappersFactory from '../Mappers/factory.js'
import {FromStaticFaqsToFaqsSchemaMarkupVOMapper} from '../Mappers/FromStaticFaqsToFaqsSchemaMarkupVOMapper.js'
import FetcherFactory from './../../fetcher/Fetchers/factory.js'
import HTTPSeoRepository from './HTTPSeoRepository.js'

export class SeoRepositoriesFactory {
  static hTTPSeoRepository = ({config}) =>
    new HTTPSeoRepository({
      config,
      httpFetcher: FetcherFactory.httpFetcher({config}),
      fetchOrFail: FetcherFactory.fetchOrFail({config}),
      fromJsonToTagCloudSeoRequestSeoMapper: SeoMappersFactory.fromJsonToTagCloudSeoRequestSeoMapper({config}),
      fromTagCloudJsonResponseToTagCloudSeoValueObjectSeoMapper:
        SeoMappersFactory.fromTagCloudJsonResponseToTagCloudSeoValueObjectSeoMapper({config}),
      fromRawsFaqsToFaqsListVOMapper: SeoMappersFactory.fromRawsFaqsToFaqsListVOMapper({config}),
      fromStaticFaqsToFaqsSchemaMarkupVOMapper: FromStaticFaqsToFaqsSchemaMarkupVOMapper.create({config}),
      seoMakeModelFaqsError: SeoErrorsFactory.seoMakeModelFaqsError,
      seoMakeModelFaqsNotFoundError: SeoErrorsFactory.seoMakeModelFaqsNotFoundError,
      toQueryString
    })
}
